import React from 'react'
import { Timeline } from 'antd'

import { formatDate } from '../../core/utils'

import { EVENT_SUBTYPES, EVENT_TYPES } from '../../common/constants'
import { renderSimpleUpdateEvent } from '../../common/helpers'

const renderDictionaryWordEvent = event => {
  const { subtype, type, original, changes, createdAt, createdBy } = event

  if (type === EVENT_TYPES.CREATE_EXPORTED_DICTIONARY_WORD) {
    return (
      <Timeline.Item key={event.id}>
        Confirmed dictionary word {changes.term} of type {changes.type}. <br />
        Origin {event.source} from entity id:{' '}
        {changes.externalReference.originEntityId}
        <br />
        {formatDate(createdAt)}
      </Timeline.Item>
    )
  }

  if (type === EVENT_TYPES.CREATE) {
    return (
      <Timeline.Item key={event.id}>
        Created {changes.type} {changes.term}
        <br />
        {formatDate(createdAt)} by {createdBy.name}
      </Timeline.Item>
    )
  }

  if (type === EVENT_SUBTYPES.DELETE) {
    return (
      <Timeline.Item key={event.id}>
        Deleted {original.type} {original.term} <br />
        {formatDate(createdAt)} by {createdBy.name}
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.DETAILS) {
    return renderSimpleUpdateEvent(event, 'term', ['languageId'])
  }

  if (subtype === EVENT_SUBTYPES.SENT_DICTIONARY_WORD_TO_INGREDIENT) {
    return (
      <Timeline.Item key={event.id}>
        Sent {original.type} {original.term} to {changes.ingredientName} as{' '}
        {changes.type}
        <br />
        {formatDate(createdAt)} by {createdBy.name}
      </Timeline.Item>
    )
  }

  return (
    <Timeline.Item key={event.id}>
      Received {original.type} {original.term} from {original.ingredientName} as{' '}
      {changes.type}
      <br />
      {formatDate(createdAt)} by {createdBy.name}
    </Timeline.Item>
  )
}

export default renderDictionaryWordEvent
